module.exports = __webpack_public_path__ + "media/images/emblems/Rueegsau-coat_of_arms-028318747a29f9464c02b48f8ae439fd.svg";